import React, { useEffect } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import useCustomTable from "components/common/table/useCustomTable";

const CustomTable = (props) => {
  const { data, columns, options = {} } = props;
  const { defaultOptions } = useCustomTable({ data, columns, options, props });

  const handleSortingChange = (updater) => {
    if (!options?.onSortingChange) return;

    const previousSorting = options?.state?.sorting ?? [];
    const nextSorting =
      typeof updater === "function" ? updater(previousSorting) : updater;

    options.onSortingChange(nextSorting);
  };

  const tableOptions = {
    ...defaultOptions,
    ...options,
    ...(options?.onSortingChange
      ? {
          onSortingChange: handleSortingChange,
        }
      : {}),

    state: {
      ...defaultOptions?.state,
      ...options?.state,
    },
  };

  const table = useMaterialReactTable({
    ...tableOptions,
  });

  const rowSelection = table.getState().rowSelection;

  const selectedRows = table
    ?.getSelectedRowModel()
    ?.flatRows?.map((row) => row?.original);

  useEffect(() => {
    if (Object.hasOwn(options, "onSelectionChange")) {
      options?.onSelectionChange(selectedRows ?? []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowSelection]);

  // useEffect(() => {
  //   const pageSizeText = document.querySelector('[aria-label="Rows per page"]');

  //   if (pageSizeText) {
  //     pageSizeText.append(" rows ");
  //   }
  // }, []);

  return <MaterialReactTable table={table} />;
};

export default CustomTable;
